import { render } from "./StepWizard.vue?vue&type=template&id=428ccffe"
import script from "./StepWizard.vue?vue&type=script&lang=js"
export * from "./StepWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__